'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _user = require('../actions/user');

var _utils = require('../utils');

var _user_list = require('../components/user_list');

var _user_list2 = _interopRequireDefault(_user_list);

var _user_filter = require('../components/user_filter');

var _user_filter2 = _interopRequireDefault(_user_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Users = _react2.default.createClass({
    displayName: 'Users',

    propTypes: {
        users: _react.PropTypes.object.isRequired,
        filter: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (!(0, _utils.filterEqual)(nextProps.filter, this.props.filter)) {
            var dispatch = nextProps.dispatch,
                filter = nextProps.filter;

            dispatch((0, _user.fetchUsersIfNeeded)(filter));
        }
    },
    componentDidMount: function componentDidMount() {
        var _props = this.props,
            dispatch = _props.dispatch,
            filter = _props.filter;

        dispatch((0, _user.fetchUsersIfNeeded)(filter));
    },
    onChange: function onChange(name, value) {

        this.props.dispatch((0, _user.filterUsers)(_defineProperty({}, name, value)));
    },
    handleStatusChange: function handleStatusChange(id, oldStatus) {
        var _props2 = this.props,
            dispatch = _props2.dispatch,
            filter = _props2.filter,
            router = _props2.router;

        var status = oldStatus === 1 ? 0 : 1;
        dispatch((0, _user.postUserIfNeeded)({ id: id, status: status }, router));
    },
    onPageChange: function onPageChange(page) {
        // 页码改变
        var _props3 = this.props,
            dispatch = _props3.dispatch,
            filter = _props3.filter;

        dispatch((0, _user.fetchUsersIfNeeded)(filter, page));
    },
    render: function render() {
        return _react2.default.createElement(
            'div',
            { id: 'users', className: 'clearfix' },
            _react2.default.createElement(_user_filter2.default, { states: ['激活', '禁用'], levels: ['普通', 'vip1', 'vip2'], onChange: this.onChange, filter: this.props.filter }),
            _react2.default.createElement(_user_list2.default, { users: this.props.users, handleStatusChange: this.handleStatusChange, onChange: this.onPageChange })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var _store$user = store.user,
        users = _store$user.users,
        filter = _store$user.filter;

    return {
        users: users,
        filter: filter
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Users);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/users.js
// module id = 1322
// module chunks = 0